import { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { close, menu } from "../assets";
import logo from '../assets/logo.png'
import { navLinks } from "../constants";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [active, setActive] = useState("Home");
  const [toggle, setToggle] = useState(false);

  return (
    <nav className="w-full flex py-6 justify-between items-center navbar">
      <img src={logo} alt="Software India Logo - Leading Software Development Company" className="w-[124px] h-[45px]" />

      <ul className="list-none sm:flex hidden justify-end items-center flex-1">
        {navLinks.map((nav, index) => (
          <li
            key={nav.id}
            className={`navba-list font-poppins font-normal cursor-pointer text-[16px] ${active === nav.title ? "text-white" : "text-dimWhite"
              } ${index === navLinks.length - 1 ? "mr-0" : "mr-10"}`}
            onClick={() => setActive(nav.title)}
          >
            <Link to={nav.id}>{nav.title}</Link>
          </li>
        ))}
        <li className="ml-6">
          <a
            href="https://wa.me/917982688080?text=Hi!%20I%20wanted%20to%20Enquire%20about%20the%20services%20offered."
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center bg-[#25D366] hover:bg-[#20BA5A] text-white font-poppins font-medium text-[14px] px-4 py-2 rounded-lg transition-colors duration-200"
            aria-label="Chat with us on WhatsApp"
          >
            <FaWhatsapp className="mr-2 text-[18px]" />
            WhatsApp
          </a>
        </li>
      </ul>

      <div className="sm:hidden flex flex-1 justify-end items-center">
        <img
          src={toggle ? close : menu}
          alt="menu"
          className="w-[28px] h-[28px] object-contain"
          onClick={() => setToggle(!toggle)}
        />

        <div
          className={`${!toggle ? "hidden" : "flex"
            } p-6 z-10 bg-black-gradient absolute top-20 w-full ml-10 my-2 min-w-[140px] rounded-xl sidebar border border-white`}
        >
          <ul className="list-none flex justify-start items-start flex-1 flex-col">
            {navLinks.map((nav, index) => (
              <li
                key={nav.id}
                className={`font-poppins font-medium cursor-pointer text-[16px] p-8 ${active === nav.title ? "text-white" : "text-dimWhite"
                  } ${index === navLinks.length - 1 ? "mb-0" : "mb-4"}`}
                onClick={() => setActive(nav.title)}
              >
                <Link to={nav.id} onClick={()=>setToggle(!toggle)}>{nav.title}</Link>
              </li>
            ))}
            <li className="p-8 pt-0">
              <a
                href="https://wa.me/917982688080?text=Hi!%20I%20wanted%20to%20Enquire%20about%20the%20services%20offered."
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center bg-[#25D366] hover:bg-[#20BA5A] text-white font-poppins font-medium text-[14px] px-4 py-2 rounded-lg transition-colors duration-200 w-full"
                onClick={()=>setToggle(!toggle)}
                aria-label="Chat with us on WhatsApp"
              >
                <FaWhatsapp className="mr-2 text-[18px]" />
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;